<div class="lvi-content">
    <div class="avatar">
        <i class="nio icon-voiture align-middle"></i>
    </div>
    <div class="lvi-body">
        <div class="title">
            <a class="label" (click)="extraOptions.openEnergie(data)">{{ data.libelle }}</a>
        </div>
        <ul class="lvi-attrs">
            <li *ngIf="data.code">
                <strong [translate]="'admin.entreprise.vehicules.energies.code'"></strong>
                <span>{{ data.code }}</span>
            </li>
            <li *ngIf="data.ordre != null">
                <strong [translate]="'admin.entreprise.vehicules.energies.ordre'"></strong>
                <span>{{ data.ordre }}</span>
            </li>
        </ul>
    </div>
    <div class="lvi-actions">
        <button mat-icon-button [matMenuTriggerFor]="listeActions">
            <mat-icon>more_vert</mat-icon>
        </button>
        <mat-menu #listeActions="matMenu">
            <button mat-menu-item (click)="deleteEnergie()" translate="global.actions.supprimer"></button>
        </mat-menu>
    </div>
</div>